import ZeaOneInstance from "./AxiosInstance/ZeaOneInstance";
import { ZeaOneAppId } from "../Constant/Setting";

export interface ZeaOnePlan {
    id: string;
    name: string;
    description: string;
    is_active: boolean;
    selected_features: string[];
    pricing_tiers: {
        amount: number;
        currency: string;
        duration: string;
    }[];
    application_id: string;
    consumable_counts: {
        USERS: number;
        AGENTS: number;
        KNOWLEDGE_BASE: number;
        VOICE_AGENT?: number;
    };
    created_at: string;
    updated_at: string | null;
}

export interface PurchaseRequest {
    user_id: string;
    user_email: string;
    user_name: string;
    plan_id: string;
    duration: string;
}

export interface PurchaseResponse {
    id: string;
    transaction_id: string;
    user_email: string;
    user_name: string;
    plan_id: string;
    application_id: string;
    amount: string;
    currency: string;
    duration: string;
    start_date: string;
    end_date: string;
    status: string;
    callback_sent: string;
    created_at: string;
    updated_at: string;
}



class ZeaOneService {
    /**
     * Fetch all available plans
     */
    async getPlans(): Promise<ZeaOnePlan[]> {
        try {
            const response = await ZeaOneInstance.get(`/api/api/v1/client/applications/${ZeaOneAppId}/plans`);
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching plans:', error);
            throw error;
        }
    }

    /**
     * Create purchase transaction
     */
    async createPurchase(request: PurchaseRequest): Promise<PurchaseResponse> {
        try {
            const response = await ZeaOneInstance.post('/api/api/v1/purchases', request);
            return response.data;
        } catch (error) {
            console.error('Error creating purchase:', error);
            throw error;
        }
    }


}

export default new ZeaOneService();
